import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import styles from './index.module.less'

export const config = {
  rowSelection: false,
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {
      title: '序号',
      dataIndex: 'sort',
      width: 200,
      render: 'sortRender',
    },
    {
      title: '费用名称',
      dataIndex: 'itemName',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    { title: '特项代码', dataIndex: 'specialCode', width: 200, ellipsis: true },
    {
      title: (
        <>
          通用计算配置
          <Tooltip
            overlayInnerStyle={{ width: 300 }}
            title={
              '通用计算配置适用于所有门店及产品，若需根据门店、产品或不同时间进行特殊计算配置，请在特殊配置中进行配置'
            }
          >
            <QuestionCircleOutlined style={{ marginLeft: 6 }} />
          </Tooltip>
        </>
      ),
      dataIndex: 'commonFormulaStr',
      render: v => (
        <Tooltip
          placement={'topLeft'}
          overlayInnerStyle={{ minWidth: 100, maxWidth: 400 }}
          title={v}
        >
          <div style={{ maxWidth: 400 }} className={styles.overEllipsis}>
            {v}
          </div>
        </Tooltip>
      ),
    },
    { title: '类型', dataIndex: 'otherConfigTypeStr', width: 200, ellipsis: true },
    { title: '是否显示', dataIndex: 'showFlag', width: 120, render: 'switchRender1' },
    { title: '状态', dataIndex: 'enabled', width: 90, fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 250, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    {
      name: 'itemNameKey',
      label: '费用名称',
    },
  ],
  footer: [
    {
      label: '下载导入模板',
      type: 'ghost',
      render: 'exportRender',
    },
    {
      label: '批量导入',
      render: 'importRender',
    },
    {
      label: '新增费用项',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
// 其他收款项目
const otherConfig = {
  rowSelection: false,
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {
      title: '序号',
      dataIndex: 'sort',
      width: 200,
      render: 'sortRender',
    },
    {
      title: '费用名称',
      dataIndex: 'itemName',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    { title: '特项代码', dataIndex: 'specialCode', width: 200, ellipsis: true },
    {
      title: (
        <>
          通用计算配置
          <Tooltip
            overlayInnerStyle={{ width: 300 }}
            title={
              '通用计算配置适用于所有门店及产品，若需根据门店、产品或不同时间进行特殊计算配置，请在特殊配置中进行配置'
            }
          >
            <QuestionCircleOutlined style={{ marginLeft: 6 }} />
          </Tooltip>
        </>
      ),
      dataIndex: 'commonFormulaStr',
      render: v => (
        <Tooltip
          placement={'topLeft'}
          overlayInnerStyle={{ minWidth: 100, maxWidth: 400 }}
          title={v}
        >
          <div style={{ maxWidth: 400 }} className={styles.overEllipsis}>
            {v}
          </div>
        </Tooltip>
      ),
    },
    { title: '类型', dataIndex: 'otherConfigTypeStr', width: 200, ellipsis: true },
    { title: '是否显示', dataIndex: 'showFlag', width: 120, render: 'switchRender1' },
    { title: '状态', dataIndex: 'enabled', width: 90, fixed: 'right', render: 'switchRender' },
    { title: '操作', dataIndex: '#', width: 250, fixed: 'right', render: 'actionRender' },
  ],
  search: [
    {
      name: 'itemNameKey',
      label: '费用名称',
    },
  ],
  footer: [
     {
      label: '下载导入模板',
      type: 'ghost',
      render: 'exportRender',
    },
    {
      label: '批量导入',
      render: 'importRender',
    },
    {
      label: '新增费用项',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
const breakManageConfig = {
  rowSelection: false,
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {
      title: '序号',
      dataIndex: 'sort',
      width: 200,
      render: 'sortRender',
    },
    {
      title: '费用名称',
      dataIndex: 'itemName',
      width: 300,
      ellipsis: {
        showTitle: true,
      },
    },
    { title: '需求标签', dataIndex: 'bizTagStr', width: 200, ellipsis: true },
    {
      title: (
        <p>
          <span>违约金最低比例（%）</span>
        </p>
      ),
      dataIndex: 'minRatio',
      width: 180,
    },
    {
      title: (
        <p>
          <span>公司违约金率（%）</span>
        </p>
      ),
      dataIndex: 'orgBreakRatio',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 250,
      fixed: 'right',
      render: 'breakManageActionRender',
    },
  ],
  search: [],
  footer: [],
  batchActions: [],
}
// 费用模版
const feesTemplateConfig = {
  rowSelection: false,
  fieldControl: false,
  tableType: 'antd',
  columns: [
    {
      title: '模板名称',
      dataIndex: 'templateName',
      width: 300,
    },
    { title: '备注', dataIndex: 'remarks', width: 200 },
    { title: '创建人', dataIndex: 'createdByName', width: 200 },
    { title: '创建时间', dataIndex: 'createdTime', width: 200, render: 'createdTimeRender' },
    { title: '状态', dataIndex: 'enabled', width: 90, render: 'templateSwitchRender' },
    {
      title: '操作',
      dataIndex: '#',
      width: 250,
      fixed: 'right',
      render: 'feesTemplateActionRender',
    },
  ],
  search: [
    {
      name: 'templateNameLike',
      label: '模板名称',
    },
  ],
  footer: [
    {
      label: '新增模板',
      type: 'primary',
      events: ['onClick:onAddTemplate'],
    },
  ],
}
export const configHandle = (key: string) => {
  switch (key) {
    case 'COST_OTHERS':
      return otherConfig
    case 'BREAK_MANAGE':
      return breakManageConfig
    case 'FEES_TEMPLATE':
      return feesTemplateConfig
    default:
      return config
  }
}
